export default __webpack_public_path__ + "static/media/educba.0d800192.webp";